import { Dialog } from "@mui/material";
import React, { useEffect, useState } from "react";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { useHistory } from "react-router-dom";
import { ReactComponent as Warning } from "assets/img/svg/WarningRed.svg";
import ModeChip from "../../../collectPayment/selectPaymentMode/components/modesChip";
import { ReactComponent as EditIcon } from "assets/img/svg/Edit2.svg";

export const filterEffectiveDateWise = (item) => {
  const today = new Date();
  today.setHours(23, 59, 59, 999); // Set to EOD
  const effectiveFrom = new Date(item.effectiveFrom);
  const effectiveTo = new Date(item.effectiveTo);
  effectiveTo.setHours(23, 59, 59, 999); // Ensure effectiveTo includes the entire day

  return effectiveFrom <= today && today <= effectiveTo;
};
export const WarningDialog = ({
  isOpen,
  setOpen,
  title = "Online charges from PSERP are automatically received in PHX, but the Quotation was not created due to an invalid concession slab master. Please raise a ticket and consult the Product Support team.",
}) => {
  const history = useHistory();
  const closeDialog = () => {
    window.open(
      history.createHref({
        pathname: `admin/studentCharges`,
      })
    )
    setOpen(false);
  };

  return (
    <Dialog open={isOpen} size="sm">
      <div className="p-4 confirm-rejection-dialog">
        <div className="d-flex justify-content-between">
          <Warning />
          {/* <CrossIcon onClick={()=>{setOpen(false)}} /> */}
        </div>

        <div className="regular-large-bold">{title}</div>
        <div className="mt-3">
          <AButton
            className="reject-btn px-5 ml-0"
            variant="danger_filled"
            onClick={closeDialog}
            style={{ width: "max-content" }}
          >
            Okay
          </AButton>
        </div>
      </div>
    </Dialog>
  );
};

export const MappedPaymentModes = ({
  tab = [],
  heading = "",
  activePaymentModeList = [],
  readOnly,
  handlePaymentModeChange,
  loanVendorsDropdown = [],
  tabKey,
  handleLoanPaymode,
  schemeOptions = [],
  vendorName,
  schemeName,
  handleLoanScheme,
  values,
  onSaveLoanScheme,
  isSecurityChargePresent 
}) => {
  const [tempLoanInfo, setTempLoanInfo] = useState({});
  const [isEditLoan,setEditLoan] = useState(true)
 
  const paymentModeHandler = (item, e, index) => {
    if (item?.type === "loan") {
      handleLoanPaymode(item);
      setTempLoanInfo(prev => ({
        ...prev,
        vendorName: prev?.vendorName?.value==item?.value?null:item,
        schemeName: null
      }));
    } else {
      handlePaymentModeChange(item);
    }
  };

  const handleTempLoanScheme = (value) => {
    setTempLoanInfo(prev => ({
      ...prev,
      schemeName:value
    }));
  };

  useEffect(() => {
    setTempLoanInfo({
      vendorName: vendorName,
      schemeName: schemeName
    });
    if (vendorName?.value && schemeName?.value) {
      setEditLoan(false);
    }
  }, [vendorName, schemeName, setEditLoan]);

  const handleSchemeSaveClick = () => {
    setEditLoan(false)
    onSaveLoanScheme(tempLoanInfo);
  };


  const activeMap = new Map(activePaymentModeList.map(item => [item.paymentModeKey, item]));

  const filteredTabWithActiveData = tab
    .map(tabItem => {
      const matchedActive = activeMap.get(tabItem.key);
      return matchedActive ? { ...tabItem, ...matchedActive } : null;
    })
    .filter(Boolean);

  const activeLoanMap = new Map();
  loanVendorsDropdown.forEach(item => {
    if (item?.label) activeLoanMap.set(item.label, item);
    if (item?.value) activeLoanMap.set(item.value, item);
  });

  const filteredloanVendor = tab
    .map(tabItem => {
      // try matching by whatever loanVendor holds (value or label)
      const matchedActive = activeLoanMap.get(tabItem?.loanVendor);
      return matchedActive ? { ...tabItem, ...matchedActive } : null;
    })
    .filter(Boolean);


 
  const getSelectedBorder = (item) => {

    try {
      if (tempLoanInfo?.vendorName?.value && item?.value) {
        if (tempLoanInfo.vendorName.value === item.value) return true;
      }
      if (item?.chargesSubType) {
        return values?.chargesSubType === item?.chargesSubType;
      }
      return values?.paymentMode?.value === item?.value;
    } catch (err) {
      return false;
    }
  };

  const handleCancelSchemeChange = () => {
    setTempLoanInfo({
      vendorName: vendorName,
      schemeName: schemeName
    });
  if(schemeName?.value)
    setEditLoan(false)
  };

  const securityCourseValidation=(isSdCoursePresent,item )=>{
    if(item?.isSdCourseValidation)
      return !!isSdCoursePresent
    else
      return true;
  }

  return (
    <>
      <div className="regular-large-bold mb-3 color-dark"> {heading} </div>

      <div className="d-flex" style={{ gap: "6px" }}>
        {
          (tabKey === 'financing' ? filteredloanVendor : filteredTabWithActiveData).map((item, index) => {
            const wrapperOnClick = (e,item) => {
              // gating: for financing, only allow vendor navigation when edit mode is true
              if (tabKey === 'financing') {
                if (!readOnly && isEditLoan) paymentModeHandler(item, e, index);
              } else {
                if (!readOnly && securityCourseValidation(isSecurityChargePresent,item)) paymentModeHandler(item, e, index);
              }
            };

            const key = `${item?.value ?? item?.text ?? index}-${index}`;
            const isDisabled =readOnly || (tabKey === 'financing' && !isEditLoan) || !securityCourseValidation(isSecurityChargePresent,item);
            return (
              <div key={key} onClick={(e)=>wrapperOnClick(e,item)}>
                <ModeChip
                  key={key}
                  icon={item?.icon}
                  text={item?.text}
                  isRecommended={item?.isRecommended}
                  className={!isDisabled ? "cursor" : "disable-events"}
                  style={
                    getSelectedBorder(item)
                      ? {
                        border: "2px solid #0F0F0F",
                        color: "#0F0F0F",
                        fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: '24px'
                      }
                      : {}
                  }
                />
              </div>
            );
          })
        }
      </div>

      {tabKey === "financing" && (
        <>
          {isEditLoan && tempLoanInfo?.vendorName && (
            <>
              <div className="regular-large-bold mb-3 mt-2 color-dark"> Choose a scheme </div>

              <div className="d-flex" style={{ gap: "6px" }}>
                {schemeOptions.length!=0? schemeOptions.map((item, index) => {
                  const schemeKey = `${item?.value ?? item?.text ?? index}-${index}`;
                  const schemeClickable = isEditLoan && !readOnly && !!tempLoanInfo?.vendorName;
                  return (
                    <div
                      key={schemeKey}
                      onClick={() => {
                        if (schemeClickable) handleTempLoanScheme(item);
                      }}
                    >
                      <ModeChip
                        key={schemeKey}
                        text={item?.value}
                        className={schemeClickable ? "cursor" : "disable-events"}
                        style={
                          tempLoanInfo?.schemeName?.value === item?.value
                            ? {
                              border: "2px solid #0F0F0F",
                              color: "#0F0F0F",
                              fontSize: "14px",
                              fontWeight: 400,
                              lineHeight: '24px'
                            }
                            : {}
                        }
                      />
                    </div>
                  );
                }): <div>-</div>}
              </div>

              {tempLoanInfo?.vendorName && tempLoanInfo?.schemeName && (
                <div className="d-flex align-items-center mt-3" style={{ gap: '8px' }}>
                  <AButton
                    variant='primary_filled'
                    onClick={handleSchemeSaveClick}
                    disabled={!tempLoanInfo?.vendorName?.value}
                    size='xs'
                  >
                    Save
                  </AButton>

                  <span>
                    <AButton
                      variant='default'
                      onClick={handleCancelSchemeChange}
                      size='sm'
                      disabled={false}
                    >
                      Discard
                    </AButton>
                  </span>
                </div>
              )}
            </>
          )}

          {!isEditLoan && (
            <div className="d-flex mt-2" style={{gap:'4px'}}>
              <span>Scheme</span>
              <span className="change-loan-scheme-button color-primary"> {schemeName?.value} </span>
              {!readOnly&&<span><EditIcon onClick={() => { setEditLoan(true) }} /></span>}
            </div>
          )}
        </>
      )}
    </>
  );
};